import { t as body_lock_default } from "./body-lock-CZ1CTkMb.js";
//#region src/scripts/extenders/mobile-nav-handler.js
var MobileNavHandler = class extends HTMLElement {
	constructor() {
		super();
		const toggle = this.querySelector(".mobile-nav-toggle");
		const mobileMegaMenu = document.querySelector(".mobile-menu");
		const itemTrigger = mobileMegaMenu.querySelectorAll("[data-side-menu]");
		const sideMenuHolders = mobileMegaMenu.querySelectorAll(".content-holder");
		const searchIcon = document.querySelector(".search-icon");
		const backButtons = mobileMegaMenu.querySelectorAll(".content-holder__back");
		toggle.addEventListener("click", () => {
			mobileMegaMenu.classList.toggle("mobile-menu--active");
			toggle.classList.toggle("active");
			if (mobileMegaMenu.classList.contains("mobile-menu--active")) {
				searchIcon.style.display = "none";
				body_lock_default.lock();
			} else {
				searchIcon.style.display = "";
				body_lock_default.unlock();
			}
		});
		itemTrigger.forEach((trigger) => {
			trigger.addEventListener("click", (event) => {
				const targetMenu = event.currentTarget.getAttribute("data-side-menu");
				sideMenuHolders.forEach((holder) => {
					if (holder.getAttribute("data-side-menu") === targetMenu) holder.classList.add("content-holder--active");
				});
			});
		});
		backButtons.forEach((button) => {
			button.addEventListener("click", () => {
				const currentContentHolder = button.closest(".content-holder");
				if (currentContentHolder) {
					currentContentHolder.classList.remove("content-holder--active");
					setTimeout(() => {
						currentContentHolder.classList.remove("content-holder--active");
					}, 0);
				}
			});
		});
	}
};
if (customElements.get("mobile-nav-handler") === void 0) customElements.define("mobile-nav-handler", MobileNavHandler);
//#endregion
